import React from "react";
import "./Risk_Disclosure_Agreement.css";
import Common_white_header from "../Common/Common_Component/Common_white_header/Common_white_header";

function Risk_Disclosure_Agreement() {
  return (
    <>
      <section className="Confidentiality_Agreement Risk_Disclosure_Agreement">
        <Common_white_header headingText={"Risk Disclosure Agreement"} />
        <div className="container">
            <div className="text_holder">
                <h6>For Money Game Platform: “WinCash Arena”</h6>
                <p>This Confidentiality Agreement (“Agreement”) is made on [Date] between WinCash Arena Pvt. Ltd., having its registered office at [Company Address] (hereinafter referred to as the “Company”), and [Recipient Name], residing at [Address] (hereinafter referred to as the “Recipient”).</p>
                <hr/>

                <p>This Confidentiality Agreement (“Agreement”) is made on [Date] between WinCash Arena Pvt. Ltd., having its registered office at [Company Address] (hereinafter referred to as the “Company”), and [Recipient Name], residing at [Address] (hereinafter referred to as the “Recipient”).</p>
                 <hr/>

                <p>This Confidentiality Agreement (“Agreement”) is made on [Date] between WinCash Arena Pvt. Ltd., having its registered office at [Company Address] (hereinafter referred to as the “Company”), and [Recipient Name], residing at [Address] (hereinafter referred to as the “Recipient”).</p>
                 <hr/>

                <p>This Confidentiality Agreement (“Agreement”) is made on [Date] between WinCash Arena Pvt. Ltd., having its registered office at [Company Address] (hereinafter referred to as the “Company”), and [Recipient Name], residing at [Address] (hereinafter referred to as the “Recipient”).</p>
                 <hr/>

                <p>This Confidentiality Agreement (“Agreement”) is made on [Date] between WinCash Arena Pvt. Ltd., having its registered office at [Company Address] (hereinafter referred to as the “Company”), and [Recipient Name], residing at [Address] (hereinafter referred to as the “Recipient”).</p>
                 <hr/>

                <p>This Confidentiality Agreement (“Agreement”) is made on [Date] between WinCash Arena Pvt. Ltd., having its registered office at [Company Address] (hereinafter referred to as the “Company”), and [Recipient Name], residing at [Address] (hereinafter referred to as the “Recipient”).</p>
                 <hr/>

                <p>This Confidentiality Agreement (“Agreement”) is made on [Date] between WinCash Arena Pvt. Ltd., having its registered office at [Company Address] (hereinafter referred to as the “Company”), and [Recipient Name], residing at [Address] (hereinafter referred to as the “Recipient”).</p>
                 <hr/>

                <p>This Confidentiality Agreement (“Agreement”) is made on [Date] between WinCash Arena Pvt. Ltd., having its registered office at [Company Address] (hereinafter referred to as the “Company”), and [Recipient Name], residing at [Address] (hereinafter referred to as the “Recipient”).</p>
                 <hr/>

                <p>This Confidentiality Agreement (“Agreement”) is made on [Date] between WinCash Arena Pvt. Ltd., having its registered office at [Company Address] (hereinafter referred to as the “Company”), and [Recipient Name], residing at [Address] (hereinafter referred to as the “Recipient”).</p>
                 <hr/>

                <p>This Confidentiality Agreement (“Agreement”) is made on [Date] between WinCash Arena Pvt. Ltd., having its registered office at [Company Address] (hereinafter referred to as the “Company”), and [Recipient Name], residing at [Address] (hereinafter referred to as the “Recipient”).</p>
            </div>
        </div>
      </section>
    </>
  );
}

export default Risk_Disclosure_Agreement;
